import React, { useCallback, useRef, useState, useEffect } from "react";
import ListPageHeader from "../utilities/ListPageHeader";
import Select from "react-select";
import { FormControl, Stack, Tab, Tabs, TextField, Select as MuiSelect, MenuItem, Tooltip, Button, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from "@mui/material";
import AgGridTable from "../utilities/AgGridTable";
import customStyles from "app/shared-components/SelectCustomStyle";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import moment from "moment/moment";
import LeaveManagementForm from "./LeaveManagementForm";
import { Link, Navigate, useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";
import LeaveOverView from "./LeaveOverView";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";

const LeaveManagement = () => {
    // const dummyData = [{ empNo: "1", employee: "test", department: "HR", worktitle: "interior", carriedDays: "85", curr_year_entitlement: "2023", leave_pro_status: "Pending", leavestatus: "Pending", confirmation_status: "approve", total_days_entitled: "2days", consumedLeaves: "2days", remaining_days: "2days" },
    // { empNo: "2", employee: "test2", department: "HR", worktitle: "IT", carriedDays: "85", curr_year_entitlement: "2023", leave_pro_status: "Pending", leavestatus: "Pending", confirmation_status: "approve", total_days_entitled: "2days", consumedLeaves: "2days", remaining_days: "2days" }]

    const gridRef = useRef();
    const childRef = useRef();
    const navigate = useNavigate();
    const [selectedRows, setSelectedRows] = useState([]);
    const [alertselectedRows, setAlertSelectedRows] = useState([]);
    const [tabValue, setTabValue] = useState(0);
    const [rowData, setRowData] = useState([]);
    const [alertRowData, setalerRowData] = useState([]);
    const [gridApi, setGridApi] = useState();
    const [selectedSize, setSelectedSize] = useState(10);
    const [successMsg, setSuccessMsg] = useState();
    const [monthsList, setMonthsList] = useState([]);
    const [empName, setEmpName] = useState();
    const [error, setError] = useState();
    const [leaveDue, setLeaveDue] = useState();
    const [yearList, setYearList] = useState([]);
    const [employMentOptions, setEmployMentOptions] = useState([]);
    // const [workingOptions, setWorkingOptions] = useState([]);
    const [leaveTypeOptions, setLeaveTypeOptions] = useState([]);
    const [employMent, setEmployMent] = useState();
    const [snackState, setSnackState] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState()
    const [selectedYear, setSelectedYear] = useState()
    const [leaveType, setLeaveType] = useState()
    // const [working, setWorking] = useState()
    const [department, setDepartment] = useState()
    const [currentEmp, setCurrentEmp] = useState();
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [departmentOptions, setDepartmentOptions] = useState([
        { label: "Management", value: "Management" },
        { label: "Administration", value: "Administration" },
        { label: "Human Resources", value: "Human Resources" },
        { label: "Sales", value: "Sales" },
        { label: "Technical Division", value: "Technical Division" },
        { label: "Design Studio", value: "Design Studio" },
        { label: "Marketing", value: "Marketing" },
        { label: "Finance", value: "Finance" },
        { label: "Accounts", value: "Accounts" },
        { label: "Logistics", value: "Logistics" },
        { label: "Training", value: "Training" },
        { label: "IT", value: "IT" },
        { label: "Projects", value: "Projects" }]);
    const [columnDefs, setColumnDefs] = useState([
        { field: 'empNo', hide: true },
        { field: 'department', enableRowGroup: true, headerName: 'Department', rowGroup: true, hide: true },
        { field: 'employee', enableRowGroup: true, headerName: 'Employee', rowGroup: true, hide: true, },
        { field: 'workType', enableRowGroup: true, headerName: 'Work-Title', minWidth: 180, },
        { field: 'carryFarward', enableRowGroup: true, headerName: 'Carried days', minWidth: 180, },
        { field: 'currentEntitlement', enableRowGroup: true, headerName: 'Current Year Entitlement', minWidth: 280, },
        { field: 'leaveProcessingStatus', enableRowGroup: true, headerName: 'Leave Processing Status', minWidth: 280, },
        { field: 'leavePlan', enableRowGroup: true, headerName: 'Leave Status', minWidth: 180, },
        { field: 'leaveApprvlStatus', enableRowGroup: true, headerName: 'Confirmation Status', minWidth: 230, },
        { field: 'noOfDays', enableRowGroup: true, headerName: 'Total Days Entitled', minWidth: 230, },
        { field: 'leaveTaken', enableRowGroup: true, headerName: 'Consumed Leaves', minWidth: 230, },
        { field: 'remainingDays', enableRowGroup: true, headerName: 'Remaining Days', minWidth: 230, },
    ])
    const [alertColumnDef, setAlertColumnDef] = useState([
        { field: 'empCode', enableRowGroup: true, headerName: 'Employee-Code', rowGroup: true, hide: true },
        { field: 'empName', enableRowGroup: true, headerName: 'Employee-Name', rowGroup: true, hide: true },
        { field: 'designation', enableRowGroup: true, headerName: 'Designation' },
        { field: 'from', enableRowGroup: true, headerName: 'Leave-From' },
        { field: 'to', enableRowGroup: true, headerName: 'Leave-Until' },

    ])
    const token = localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));
    const LeaveUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.leave}`;

    const handleTabChange = (event, value) => {
        setTabValue(value);
    }

    const onGridReady = (params) => {
        loadAllLeaveList()
        loadLeaveAlertsList()
        setGridApi(params.api);
    };

    const handleApproveLeave = async (params) => {
        if (selectedRows) {
            try {
                let year = (new Date(selectedRows[0].fromDate).getFullYear(), new Date(selectedRows[0].toDate).getFullYear())
                let model = {
                    leaveInfoId: selectedRows[0].leaveInfoId,
                    leaveStatus: "CONFIRMED",
                    leavePlan: selectedRows[0].leavePlan,
                    year: year,
                    // leaveApproverLvl1:token?.email,
                    finalApprovedDate: selectedRows[0].finalApprovedDate ? selectedRows[0].finalApprovedDate : new Date()
                }
                if(token?.scope?.includes("ROLE_HR")){
                    model = { ...model, leaveApproverLvl1: token?.email }
                }
                else if(token?.scope?.includes("ROLE_MD")){
                    model = {...model,leaveApproverLvl2: token?.email }
                }
                // if (selectedRows[0].leaveApproverLvl1) {
                //     console.log("Level 1 approval");
                //     model.leaveApproverLvl1 = selectedRows[0].leaveApproverLvl1;
                //     model.leaveApproverLvl2 = token?.email;
                // } else if (selectedRows[0].leaveApproverLvl2) {
                //     console.log("Level 2 approval");
                //     model.leaveApproverLvl2 = selectedRows[0].leaveApproverLvl2;
                // } else {
                //     console.log("No approval level found, setting Level 1");
                //     model.leaveApproverLvl1 = token?.email;
                // }

        
                console.log(model);
                const leaveData = await OAuthService.addData(LeaveUrl + '/actionOnLeave', model);
                if (leaveData) {
                    setSuccessMsg("Leave Approved successfully.");
                    setSnackState(true)
                    loadAllLeaveList(tabValue, department, employMent,  leaveType, selectedMonth, selectedYear)
                }
            } catch (error) {
                setError(error?.response?.data?.errorMessage || error.message)
            }
        }
    }

    const handleRejectLeave = async (params) => {
        if (selectedRows) {
            try {
                let year = (new Date(selectedRows[0].fromDate).getFullYear(), new Date(selectedRows[0].toDate).getFullYear())
                let model = {
                    leaveInfoId: selectedRows[0].leaveInfoId,
                    leaveStatus: "REJECTED",
                    leavePlan: selectedRows[0].leavePlan,
                    year: year,
                    finalApprovedDate: selectedRows[0].finalApprovedDate ? selectedRows[0].finalApprovedDate : new Date()
                }
                if (selectedRows[0].leaveApproverLvl1) {
                    model = { ...model, leaveApproverLvl2: token?.email }
                } else {
                    model = { ...model, leaveApproverLvl1: token?.email }
                }
                const leaveData = await OAuthService.addData(LeaveUrl + '/actionOnLeave', model);
                if (leaveData) {
                    setSuccessMsg("Leave Rejected successfully.");
                    setSnackState(true)
                    loadAllLeaveList(tabValue, department, employMent, leaveType, selectedMonth, selectedYear)
                }
            } catch (error) {
                setError(error?.response?.data?.errorMessage || error.message)
            }
        }
    }

    const handleCancleLeave = async () => {
        if (selectedRows) {
            try {
                let year = (new Date(selectedRows[0].fromDate).getFullYear(), new Date(selectedRows[0].toDate).getFullYear())
                let model = {
                    leaveInfoId: selectedRows[0].leaveInfoId,
                    leaveStatus: "CANCELED",
                    leavePlan: selectedRows[0].leavePlan,
                    year: year,
                    finalApprovedDate: selectedRows[0].finalApprovedDate ? selectedRows[0].finalApprovedDate : new Date()
                }
                if (selectedRows[0].leaveApproverLvl1) {
                    model = { ...model, leaveApproverLvl2: token?.email }
                } else {
                    model = { ...model, leaveApproverLvl1: token?.email }
                }
                const leaveData = await OAuthService.addData(LeaveUrl + '/actionOnLeave', model);
                if (leaveData) {
                    setSuccessMsg("Leave Canceled successfully.");
                    setSnackState(true)
                    loadAllLeaveList(tabValue, department, employMent, leaveType, selectedMonth, selectedYear)
                }
            } catch (error) {
                setError(error?.response?.data?.errorMessage || error.message)
            }
        }
    }

    const handleViewLeave = (params) => {

    };

    // const handleViewPrintLeave = (params) => {

    // };

    const handleCalenderLeave = (params) => {

    };

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

    const onAlertSelectionChanged = (params) => {
        setAlertSelectedRows(params.api.getSelectedRows());
    }

    // const handleSendMail = (params) => {

    // }

    const onPageSizeChanged = useCallback((e) => {
        setSelectedSize(e.target.value);
        var value = e.target.value;
        gridRef.current.api.paginationSetPageSize(value);
    }, []);


    const handleMonthCahnge = (data) => {
        setSelectedMonth(data.value)
        loadAllLeaveList()
    }

    const handleYearCahnge = (data) => {
        setSelectedYear(data.value)
        loadAllLeaveList()
    }

    const handleEmployment = (data) => {
        setEmployMent(data.value)
        loadAllLeaveList()
    }

    const handleEmployeeChange = (event) => {
        setEmpName(event.target.value)
    }

    const handleLeaveDueChaneg = (event) => {
        setLeaveDue(event.target.value)
    }

    const handleLeaveType = (data) => {
        setLeaveType(data.value)
        loadAllLeaveList()
    }

    // const handleworking = (data) => {
    //     setWorking(data.value)
    //     loadAllLeaveList()
    // }

    const handleDepartment = (data) => {
        setDepartment(data.value)
        loadAllLeaveList()
    }

    const handleEditLeave = () => {
        const id = selectedRows[0].leaveInfoId
        navigate(`/LeaveManagementForm/${id}`)
    }

    useEffect(() => {
        const monthlist = moment.months();
        const months = monthlist.map((key, item) => ({ label: key, value: key, id: item }));
        setMonthsList(months)
        const cyear = (new Date()).getFullYear();
        let years = Array.from(new Array(5), (val, index) => { return { label: cyear - index, value: cyear - index } });
        let Newyears = Array.from(new Array(2), (val, index) => { return { label: cyear + index, value: cyear + index } });
        let RemoveYears = Newyears.slice(1)
        setYearList([...RemoveYears, ...years]);

        const loadAllLeaveType = async () => {
            const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.leaveCategories}`;
            try {
                const list = await OAuthService.getList(url);
                if (list?.data) {
                    const allCat = list?.data?._embedded?.leaveCategories.map((data) => {
                        return { label: data.category, value: data.category }
                    })
                    setLeaveTypeOptions(allCat)
                }

            } catch (error) {

            }
        }
        loadAllLeaveType();

        const loadAllEmployementType = async () => {
            const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employementTypes}`;
            try {
                const list = await OAuthService.getList(url);
                if (list?.data) {
                    const allCat = list?.data?._embedded?.employementTypes.map((data) => {
                        return { label: data.name, value: data.code }
                    })
                    setEmployMentOptions(allCat)
                }

            } catch (error) {

            }
        }
        loadAllEmployementType();

        const getCurrentEmployee = async () => {
            const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employees}`;
            const email = token?.email;

            const emp = await OAuthService.getList(url + `/search/findEmployeeByEmail?email=${email}`);
            setCurrentEmp(emp?.data)
        }
        getCurrentEmployee();

        if (tabValue === 0) {
            loadAllLeaveList();
        } else if (tabValue === 1) {
            loadLeaveAlertsList();
        }
    }, []);

    useEffect(() => {
        if (tabValue === 0) {
            loadAllLeaveList();
        } else if (tabValue === 1) {
                loadLeaveAlertsList();
        }
    }, [tabValue, department, selectedSize, employMent,  leaveType, selectedMonth, selectedYear, empName, leaveDue])

    const monthNameToNumber = {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
    };

    const loadAllLeaveList = async (months) => {
        try {
            let FilterData = {};
            if (leaveType) {
                FilterData = {...FilterData , leaveCategory: leaveType}
            }
            if(selectedYear){
                FilterData = {...FilterData , year: [selectedYear]}
            }
            if(selectedMonth){
                FilterData = {...FilterData , month: [selectedMonth]}
            }
            if(employMent){
                FilterData = {...FilterData , empType: employMent}
            }
            if(department){
                FilterData = {...FilterData , department: department}
            }
            // if (FilterData) {
            //     FilterData += `?${FilterData}`;
            // }
            const listData = await OAuthService.addData(LeaveUrl + `/getempleaveinfo`,FilterData);
            if (listData?.data) {
                const list = listData?.data?.map((data) => {
                    data.department = data.employee.department,
                        data.employee = data.employee.empFirstName,
                        data.noOfDays = data.leaveType.noOfDays,
                        data.carryFarward = data.leaveType.carryFarward,
                        data.leaveTaken = data.leaveType.leaveTaken,
                        data.remainingDays = data.leaveType.remainingDays,
                        data.currentEntitlement = data.carryFarward + data.remainingDays,
                        data.leaveProcessingStatus = (data.leaveApprvlStatus === "CONFIRMED" || data.leaveApprvlStatus === "CANCELED" || data.leaveApprvlStatus === "REJECTED") ? "Completed" : "Pending"

                    // data
                    return data
                })
                setRowData(list)

            }
            else {
                setRowData([])
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    const loadLeaveAlertsList = async () => {
        try {
            let queryObj = '';
            if(empName || leaveDue){
                queryObj = `?query=${empName || leaveDue}`
            }
            const listData = await OAuthService.getList(LeaveUrl + `/getAlertList${queryObj}`);
            console.log(listData?.data);
                setalerRowData(listData?.data)

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    const LeaveManagementFilter = () => {
        return (
            <>
                {(tabValue === 0) ? (
                    <>
                        {currentEmp &&
                            <Tooltip title={"Add Leave"}>
                                <Link to={"/LeaveManagementForm"} className="nav-link">
                                    <Button
                                        variant="contained"
                                        color="warning"
                                        style={{ marginLeft: "4px" }}
                                    // onClick={handleAddButton}
                                    >
                                        <FuseSvgIcon>heroicons-solid:plus-circle</FuseSvgIcon>
                                    </Button>
                                </Link>
                            </Tooltip >
                        }

                        {(selectedRows && selectedRows.length > 0) &&
                            <>
                                <Tooltip title={"Edit Leave"}>
                                    {/* <Link to={"/LeaveManagementForm"} className="nav-link"> */}
                                    <Button
                                        variant="contained"
                                        color="warning"
                                        style={{ marginLeft: "4px" }}
                                        onClick={handleEditLeave}
                                    >
                                        <FuseSvgIcon>heroicons-solid:pencil</FuseSvgIcon>
                                    </Button>
                                    {/* </Link> */}
                                </Tooltip>


                                <Tooltip title={"View Leave"}>
                                    <Button
                                        variant="contained"
                                        color="warning"
                                        style={{ marginLeft: "4px" }}
                                        onClick={handleViewLeave}
                                    >
                                        <FuseSvgIcon>heroicons-solid:eye</FuseSvgIcon>
                                    </Button>
                                </Tooltip>
                                <>
                                    {selectedRows[0].leaveApprvlStatus === 'WAITING' &&
                                        <Tooltip title={"Approve Leave"}>
                                            <Button
                                                variant="contained"
                                                color="warning"
                                                style={{ marginLeft: "4px" }}
                                                onClick={handleApproveLeave}
                                            >
                                                <FuseSvgIcon>heroicons-outline:check-circle</FuseSvgIcon>
                                            </Button>
                                        </Tooltip>
                                    }
                                    <Tooltip title={"Reject Leave"}>
                                        <Button
                                            variant="contained"
                                            color="warning"
                                            style={{ marginLeft: "4px" }}
                                            onClick={handleRejectLeave}
                                        >
                                            <FuseSvgIcon>material-solid:block</FuseSvgIcon>
                                        </Button>
                                    </Tooltip>
                                </>

                                <Tooltip title={"Cancel Leave"} >
                                    <Button
                                        variant="contained"
                                        color="warning"
                                        style={{ marginLeft: "4px" }}
                                        onClick={handleCancleLeave}
                                    >
                                        <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
                                    </Button>
                                </Tooltip>

                                {/* <Tooltip title={"Print Leave"}>
                                    <Button
                                        variant="contained"
                                        color="warning"
                                        style={{ marginBottom: '5px', fontWeight: 'bold', marginLeft: "4px" }}
                                        onClick={handleViewPrintLeave}
                                    >
                                        <FuseSvgIcon className="text-xl">heroicons-outline:printer</FuseSvgIcon>
                                    </Button>
                                </Tooltip> */}
                            </>
                        }

                        <Tooltip title={"Calender Leave"}>
                            <Link to={"/LeaveCalendar"} className="nav-link">
                                <Button
                                    variant="contained"
                                    color="warning"
                                // onClick={handleCalenderLeave}
                                >
                                    <FuseSvgIcon>material-outline:calendar_today</FuseSvgIcon>
                                </Button>
                            </Link>
                        </Tooltip>
                    </>
                ) : (
                    (alertselectedRows && alertselectedRows.length > 0) &&
                    <>
                        {/* <Tooltip title={"Send Leave"}>
                            <Button
                                variant="contained"
                                color="warning"
                                style={{ marginLeft: "4px" }}
                                onClick={handleSendMail}
                            >
                                <FuseSvgIcon>material-outline:forward_to_inbox</FuseSvgIcon>
                            </Button>
                        </Tooltip> */}
                    </>

                )
                }
            </>
        )
    }
    return (
        <>
            {(token?.scope?.includes("ROLE_MD") || token?.scope?.includes("ROLE_HR")) &&
                <>
                    <ListPageHeader
                        componentName="Leave Management"
                        headerInputFields={LeaveManagementFilter()}
                        pageName="Leave Management Dashboard"
                        successMsg={successMsg}
                        snackState={snackState}
                        gridRef={gridRef}
                        showPaginationDropdown={false}
                    />
                  <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        indicatorColor="secondary"
                        textColor="inherit"
                        variant="scrollable"
                        scrollButtons="auto"
                        classes={{ root: 'w-full border-b-1' }}
                    >
                        <Tab 
                            label="List" 
                            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
                        />
                        <Tab 
                            label="Alert" 
                            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
                        />
                    </Tabs>

                    <div className={tabValue !== 0 ? 'hidden' : 'h-full'}>
                        <div direction={'row'} className="mb-10 md:px-16 flex flex-row-reverse ">
                            <div className="flex flex-row">
                                <div className="flex flex-row justify-between items-baseline">
                                    {/* <FormControl className={"flex"} size="small">
                                        <label className="pt-12 min-w-fit">Page Size</label>
                                        <MuiSelect onChange={onPageSizeChanged} className='h-fit min-w-[150px]' value={selectedSize} id="page-size"
                                            inputProps={{
                                                sx: { 'padding': '10px' },
                                            }}
                                        >
                                            <MenuItem value="10">10</MenuItem>
                                            <MenuItem value="20">20</MenuItem>
                                            <MenuItem value="50">50</MenuItem>
                                            <MenuItem value="100">100</MenuItem>
                                        </MuiSelect>
                                    </FormControl> */}
                                    {/* 
                                    <Stack className="ml-10 pt-12 ">
                                        <label className="basis-0 float-left">Company</label>
                                        <TextField
                                            name='company'
                                            className=" min-w-[150px] h-[30px]"
                                            value={company}
                                            onChange={handleCompanyChange}
                                            inputProps={{
                                                sx: { 'padding': '10px' },
                                            }}
                                        />
                                    </Stack> */}

                                    <Stack className="ml-10">
                                        <label className="pt-12 min-w-fit">Employment</label>
                                        <Select
                                            name="employment"
                                            className=" min-w-[150px] h-[30px]"
                                            onChange={handleEmployment}
                                            value={(employMent && employMentOptions.length > 0) && employMentOptions.filter((data) => data.value === employMent)}
                                            options={employMentOptions}
                                            styles={customStyles('', '', '0px')}
                                        />
                                    </Stack>
                                    <Stack className="ml-10">
                                        <label className="pt-12 min-w-fit">Department</label>
                                        <Select
                                            name="department"
                                            className=" min-w-[150px] h-[30px]"
                                            onChange={handleDepartment}
                                            value={(department && departmentOptions.length > 0) && departmentOptions.filter((data) => data.value === department)}
                                            options={departmentOptions}
                                            styles={customStyles('', '', '0px')}
                                        />
                                    </Stack>
                                    {/* <Stack className="ml-10">
                                        <label className="pt-12 min-w-fit">Working Personnel</label>
                                        <Select
                                            name="working_personnel"
                                            className=" min-w-[150px] h-[30px]"
                                            onChange={handleworking}
                                            value={(working && workingOptions.length > 0) && workingOptions.filter((data) => data.value === working)}
                                            options={workingOptions}
                                            styles={customStyles('', '', '0px')}
                                        />
                                    </Stack> */}
                                    <Stack className="ml-10">
                                        <label className="pt-12 min-w-fit">Leave Type</label>
                                        <Select
                                            name="leave_type"
                                            className=" min-w-[150px] h-[30px]"
                                            onChange={handleLeaveType}
                                            value={(leaveType && leaveTypeOptions.length > 0) && leaveTypeOptions.filter((data) => data.value === leaveType)}
                                            options={leaveTypeOptions}
                                            styles={customStyles('', '', '0px')}
                                        />
                                    </Stack>
                                    <Stack className="ml-10">
                                        <label className="pt-12 min-w-fit">Month</label>
                                        <Select
                                            name="month"
                                            className=" min-w-[150px] h-[30px]"
                                            value={(selectedMonth && monthsList.length > 0) && monthsList.filter((data) => data.value === selectedMonth)}
                                            onChange={handleMonthCahnge}
                                            options={monthsList}
                                            styles={customStyles('', '', '0px')}
                                        />
                                    </Stack>
                                    <Stack className="ml-10">
                                        <label className="pt-12 min-w-fit">Year</label>
                                        <Select
                                            name="year"
                                            className=" min-w-[150px] h-[30px]"
                                            value={(selectedYear && yearList.length > 0) && yearList.filter((data) => data.value === selectedYear)}
                                            onChange={handleYearCahnge}
                                            options={yearList}
                                            styles={customStyles('', '', '0px')}
                                        />
                                    </Stack>
                                </div>
                            </div>
                        </div>
                        <AgGridTable
                            rowData={rowData}
                            columnDefs={columnDefs}
                            onGridReady={onGridReady}
                            gridRef={gridRef}
                            onSelectionChanged={onSelectionChanged}
                            // saveGridStateName={'LeaveManagement'}
                            groupCheckBox={false}
                            rowSelection={'single'}
                            hideCheckbox={true}
                        />
                    </div>

                    <div className={tabValue !== 1 ? 'hidden' : 'h-full'}>
                        <div direction={'row'} className="mb-10 md:px-16 flex flex-row-reverse ">
                            <div className="flex flex-row">
                                <div className="flex flex-row justify-between items-baseline">
                                    <Stack className="self-end">
                                        <label className="pt-12 min-w-fit">Employee Name</label>
                                        <TextField
                                            name='emp_name'
                                            value={empName}
                                            onChange={handleEmployeeChange}
                                            inputProps={{
                                                sx: { 'padding': '10px' },
                                            }}
                                        />
                                    </Stack>
                                    <Stack className="ml-10">
                                        <label className="pt-12 min-w-fit">Leave Due In</label>
                                        <TextField
                                            name='leave_due'
                                            value={leaveDue}
                                            onChange={handleLeaveDueChaneg}
                                            inputProps={{
                                                sx: { 'padding': '10px' },
                                            }}
                                        />
                                    </Stack>
                                </div>
                            </div>
                        </div>
                        <AgGridTable
                            rowData={alertRowData}
                            columnDefs={alertColumnDef}
                            onGridReady={onGridReady}
                            // gridRef={gridRef}
                            onSelectionChanged={onAlertSelectionChanged}
                            // saveGridStateName={'LeaveManagement'}
                            groupCheckBox={false}
                            rowSelection={'single'}
                            hideCheckbox={true}
                        />
                    </div>
                </>
            }
            {(!token?.scope?.includes("ROLE_MD") && !token?.scope?.includes("ROLE_HR")) &&
                <LeaveOverView />
            }
        </>

    )
}

export default LeaveManagement